import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e79da6e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 660 × 880 px (3:4 竖图)", -1))
const _hoisted_4 = {
  key: 0,
  style: {"color":"#909399","font-size":"12px","margin-top":"4px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("SSSR")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("SSR")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("SR")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("无限惊喜")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#909399","font-size":"12px","margin-top":"4px"} }, " 勾选的等级被抽中时会重置盒中盒计数器 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#909399","margin-left":"8px"} }, "机器人自动购买，仅对普通类型生效", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后仅内部用户可见", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 新增赏品 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 按价格排序 ")
const _hoisted_16 = { class: "box-item-table-wrapper" }
const _hoisted_17 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 box-item-table" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-product" }, "商品"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-price" }, "回收价"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-type" }, "赏品类型"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-level" }, "等级"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-qty" }, "数量"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-range" }, "开始"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-range" }, "结束"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-combo" }, "串数"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-actions" }, "操作")
  ])
], -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 上移 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 下移 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_23 = { colspan: "5" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 新增楼层 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 新增赏品 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 按价格排序 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "商品"),
    /*#__PURE__*/_createElementVNode("th", null, "回收价"),
    /*#__PURE__*/_createElementVNode("th", null, "赏品类型"),
    /*#__PURE__*/_createElementVNode("th", null, "等级"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "效果"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 上移 ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 下移 ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_37 = { colspan: "5" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 新增隐藏赏品 ")
const _hoisted_41 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "商品"),
    /*#__PURE__*/_createElementVNode("th", null, "回收价"),
    /*#__PURE__*/_createElementVNode("th", null, "概率"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_NewBoxItemInfoModal = _resolveComponent("NewBoxItemInfoModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.box_info,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "图片",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "avatar-uploader",
                action: "https://jsonplaceholder.typicode.com/posts/",
                "show-file-list": false,
                "auto-upload": false,
                ref: "uploadRef",
                "on-change": _ctx.onChange
              }, {
                default: _withCtx(() => [
                  (_ctx.imageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imageUrl,
                        class: "avatar"
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "avatar-uploader-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_plus)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["on-change"]),
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "目录",
            prop: "box_category_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.box_info.box_category_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.box_info.box_category_id) = $event)),
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_categories, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "消费类型",
            prop: "box_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.box_info.box_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.box_info.box_type) = $event)),
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_types, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.box_info.box_type == 'cash')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "仅限现金"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.is_cash_only,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.box_info.is_cash_only) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "充值用" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_recharge,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.box_info.is_recharge) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "置顶" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_top,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.box_info.is_top) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.box_info.box_type == 'cash' && !_ctx.box_info.is_cash_only)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: `${_ctx.pointLabel}抵扣`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.is_allow_point,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.box_info.is_allow_point) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.box_info.box_type == 'event_point')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: "对应活动",
                prop: "event_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.box_info.event_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.box_info.event_id) = $event)),
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event_options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.name,
                          value: item.id,
                          key: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "抽赏类型",
            prop: "game_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.box_info.game_type,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.box_info.game_type) = $event)),
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game_types, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.key,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.box_info.game_type == 'infinity')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_el_form_item, {
                  label: "双倍类型",
                  prop: "double_type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.box_info.double_type,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.box_info.double_type) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.double_types, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.key,
                            value: item.value,
                            key: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.box_info.double_type != 'nonp')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "双倍发数",
                      prop: "double_count"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.box_info.double_count,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.box_info.double_count) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'normal' || _ctx.box_info.game_type == 'card')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_el_form_item, { label: "开启吃菜" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.box_info.is_eat,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.box_info.is_eat) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.box_info.is_eat)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, {
                        label: "吃菜商品池",
                        prop: "eat_product_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.box_info.eat_product_id,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.box_info.eat_product_id) = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择吃菜商品池"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eat_products, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.key,
                                  value: item.value,
                                  key: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "吃菜数量",
                        prop: "eat_count"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.box_info.eat_count,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.box_info.eat_count) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'normal' || _ctx.box_info.game_type == 'card')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createVNode(_component_el_form_item, { label: "开启做菜" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.box_info.is_cook,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.box_info.is_cook) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.box_info.is_cook)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, {
                        label: "做菜商品池",
                        prop: "cook_product_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.box_info.cook_product_id,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.box_info.cook_product_id) = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择做菜商品池"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cook_products, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.key,
                                  value: item.value,
                                  key: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "做菜数量",
                        prop: "cook_count"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.box_info.cook_count,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.box_info.cook_count) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type != 'level')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _createVNode(_component_el_form_item, { label: "开启盒中盒" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.box_info.is_box,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.box_info.is_box) = $event)),
                      onChange: _ctx.onBoxInBoxChange
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                (_ctx.box_info.is_box)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "盒中盒商品",
                      prop: "box_product_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.box_info.box_product_id,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.box_info.box_product_id) = $event)),
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_products, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.key,
                                value: item.value,
                                key: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.box_info.game_type === 'normal')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 常规池：奖池售罄后，未获得全局赏的用户自动抽取一次盒中盒 "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.box_info.is_box && _ctx.box_info.game_type === 'infinity')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_form_item, {
                        label: "触发次数",
                        prop: "box_trigger_count"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _ctx.box_info.box_trigger_count,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.box_info.box_trigger_count) = $event)),
                            min: 1,
                            placeholder: "连续未出SSSR的次数"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "重置等级" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: _ctx.boxResetLevelsArray,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.boxResetLevelsArray) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox, { label: "SSSR" }, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_checkbox, { label: "SSR" }, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_checkbox, { label: "SR" }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_checkbox, { label: "infinity_surprise" }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "等级限制",
            prop: "level_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.box_info.level_id,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.box_info.level_id) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levels, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.name,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "当日流水限制",
            prop: "water_need"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.box_info.water_need,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.box_info.water_need) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.box_info.name,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.box_info.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "单价",
            prop: "price"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.box_info.price,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.box_info.price) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.box_info.game_type == 'normal' || _ctx.box_info.game_type == 'card')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 7,
                label: "最大抽数（0 为不限制）",
                prop: "get_limit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.box_info.get_limit,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.box_info.get_limit) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'normal' && _ctx.box_info.get_limit > 0)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 8,
                label: "每日重置发数限制"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.get_limit_reset,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.box_info.get_limit_reset) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "每帐号限抽一次" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_one_time_purchase,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.box_info.is_one_time_purchase) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "福利套" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_welfare,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.box_info.is_welfare) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ]),
            _: 1
          }),
          (_ctx.box_info.game_type == 'normal')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 9,
                label: "车祸补偿"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.is_crash,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.box_info.is_crash) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'infinity')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 10,
                label: "矿难补偿"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.is_infinity_crash,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.box_info.is_infinity_crash) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "积分累计" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_increase_membership_point,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.box_info.is_increase_membership_point) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.box_info.game_type == 'normal' || _ctx.box_info.game_type == 'card')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                _createVNode(_component_el_form_item, { label: "自动开箱" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.box_info.is_auto_open,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.box_info.is_auto_open) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.box_info.is_auto_open)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "自动开箱数量"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.box_info.auto_open_count,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.box_info.auto_open_count) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'normal')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 12,
                label: "自动上套"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.box_info.is_auto_append,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.box_info.is_auto_append) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "隐藏" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_hide,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.box_info.is_hide) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "仅内部测试" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.is_test,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.box_info.is_test) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ]),
            _: 1
          }),
          _hoisted_12,
          _createVNode(_component_el_form_item, { label: "启用" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.enabled,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.box_info.enabled) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "允许选箱" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.box_info.allow_to_choose_box,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.box_info.allow_to_choose_box) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_13,
          (_ctx.box_info.game_type != 'level')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                _createVNode(_component_el_form_item, { label: "赏品列表" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_button, {
                      type: "button",
                      status: "primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_new_box_item_info",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.setAddType('normal')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_button, {
                      type: "button",
                      status: "primary",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.sortByPrice()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedBoxItemInfos, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.id
                        }, [
                          (item._destroy != 1)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                _createElementVNode("td", null, _toDisplayString(item.brand) + " - " + _toDisplayString(item.product), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_el_select, {
                                    modelValue: item.item_type,
                                    "onUpdate:modelValue": ($event: any) => ((item.item_type) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_item_types, (opt) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: opt.key,
                                          value: opt.value,
                                          key: opt.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  (item.item_type == 'normal' || item.item_type == 'range_gift' || item.item_type == 'run_gift')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 0,
                                        modelValue: item.level,
                                        "onUpdate:modelValue": ($event: any) => ((item.level) = $event)
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item_levels(item), (lvl) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              label: lvl,
                                              value: lvl,
                                              key: lvl
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: item.quantity,
                                    "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                    min: 1,
                                    controls: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", null, [
                                  (item.item_type == 'range_gift' || item.item_type == 'run_gift')
                                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                                        key: 0,
                                        modelValue: item.range_from,
                                        "onUpdate:modelValue": ($event: any) => ((item.range_from) = $event),
                                        min: 0,
                                        controls: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  (item.item_type == 'range_gift' || item.item_type == 'run_gift')
                                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                                        key: 0,
                                        modelValue: item.range_to,
                                        "onUpdate:modelValue": ($event: any) => ((item.range_to) = $event),
                                        min: 1,
                                        controls: true
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  (item.item_type == 'combo')
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: item.combo_count,
                                        "onUpdate:modelValue": ($event: any) => ((item.combo_count) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_vxe_button, {
                                    type: "button",
                                    status: "primary",
                                    onClick: ($event: any) => (_ctx.move_up(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_20
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_vxe_button, {
                                    type: "button",
                                    status: "primary",
                                    onClick: ($event: any) => (_ctx.move_down(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_21
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_vxe_button, {
                                    type: "button",
                                    status: "primary",
                                    onClick: ($event: any) => (_ctx.destroy_item(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_22
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_23, [
                          _createTextVNode(" 套系金额：" + _toDisplayString(_ctx.box_info_total()) + " / 赏品金额：" + _toDisplayString(_ctx.item_total()) + " / 利润金额：" + _toDisplayString(_ctx.total_profit()) + " / 利润比例：" + _toDisplayString(_ctx.total_profit_percent()) + " / 数量合计：" + _toDisplayString(_ctx.total_count()), 1),
                          (_ctx.level_count_summary())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " （" + _toDisplayString(_ctx.level_count_summary()) + "）", 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_25
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.box_info.game_type == 'level')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                _createVNode(_component_el_form_item, { label: "楼层列表" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_button, {
                      type: "button",
                      status: "primary",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.addLevel()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_info.box_level_item_infos_attributes, (level) => {
                  return (_openBlock(), _createElementBlock("div", { key: level }, [
                    (level._destroy != 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_form_item, {
                            label: '楼层 ' + level.level
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_vxe_button, {
                                type: "button",
                                status: "primary",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#kt_modal_new_box_item_info",
                                onClick: ($event: any) => (_ctx.setAddType('level', level))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_vxe_button, {
                                type: "button",
                                status: "primary",
                                onClick: ($event: any) => (_ctx.sortByPrice(level))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_vxe_button, {
                                type: "button",
                                status: "primary",
                                onClick: ($event: any) => (_ctx.destroyLevel(level))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_29
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          (level.level > 1)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "初次抵达赠送",
                                prop: "gift_type"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: level.gift_type,
                                    "onUpdate:modelValue": ($event: any) => ((level.gift_type) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_level_item_info_gift_types, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.key,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                  (level.gift_type === 'membership_point' || level.gift_type === 'extra_point')
                                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                                        key: 0,
                                        modelValue: level.gift_number,
                                        "onUpdate:modelValue": ($event: any) => ((level.gift_number) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true),
                                  (level.gift_type === 'product')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#kt_modal_new_box_item_info",
                                        onClick: ($event: any) => (_ctx.setAddType('levelInfo', level))
                                      }, _toDisplayString(level.product_id ? level.product_name : '选择商品'), 9, _hoisted_30))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("table", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedLevelBoxItemInfos(level), (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: item.id
                                }, [
                                  (item._destroy != 1)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                                        _createElementVNode("td", null, _toDisplayString(item.brand) + " - " + _toDisplayString(item.product), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.item_type,
                                            "onUpdate:modelValue": ($event: any) => ((item.item_type) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.level_box_item_types, (opt) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  label: opt.key,
                                                  value: opt.value,
                                                  key: opt.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          (item.item_type == 'normal' || item.item_type == 'range_gift' || item.item_type == 'run_gift')
                                            ? (_openBlock(), _createBlock(_component_el_select, {
                                                key: 0,
                                                modelValue: item.level,
                                                "onUpdate:modelValue": ($event: any) => ((item.level) = $event)
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item_levels(item), (lvl) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      label: lvl,
                                                      value: lvl,
                                                      key: lvl
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_el_input_number, {
                                            modelValue: item.quantity,
                                            "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                            min: 1
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.level_type,
                                            "onUpdate:modelValue": ($event: any) => ((item.level_type) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.level_types, (opt) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  label: opt.key,
                                                  value: opt.value,
                                                  key: opt.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_vxe_button, {
                                            type: "button",
                                            status: "primary",
                                            onClick: ($event: any) => (_ctx.move_up(item, level))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_34
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_vxe_button, {
                                            type: "button",
                                            status: "primary",
                                            onClick: ($event: any) => (_ctx.move_down(item, level))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_35
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_vxe_button, {
                                            type: "button",
                                            status: "primary",
                                            onClick: ($event: any) => (_ctx.destroy_item(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_36
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128)),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_37, [
                                  _createTextVNode(" 套系金额：" + _toDisplayString(_ctx.box_info_total(level)) + " / 赏品金额：" + _toDisplayString(_ctx.item_total(level)) + " / 利润金额：" + _toDisplayString(_ctx.total_profit(level)) + " / 利润比例：" + _toDisplayString(_ctx.total_profit_percent(level)) + " / 数量合计：" + _toDisplayString(_ctx.total_count(level)), 1),
                                  (_ctx.level_count_summary(level))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, " （" + _toDisplayString(_ctx.level_count_summary(level)) + "）", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _hoisted_39
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "隐藏赏品列表" }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_new_box_item_info",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.setAddType('hidden')))
              }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("table", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.box_info.hidden_gifts_attributes, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  (item._destroy != 1)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                        _createElementVNode("td", null, _toDisplayString(item.brand) + " - " + _toDisplayString(item.product), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_input_number, {
                            modelValue: item.percent,
                            "onUpdate:modelValue": ($event: any) => ((item.percent) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_vxe_button, {
                            type: "button",
                            status: "primary",
                            onClick: ($event: any) => (_ctx.destroy_item(item))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_44
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _hoisted_45,
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _createVNode(_component_NewBoxItemInfoModal, { add_box_item_infos: _ctx.add_box_item_infos }, null, 8, ["add_box_item_infos"])
  ], 64))
}